var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueTelegramLogin',{attrs:{"mode":"callback","telegram-login":_vm.config.TELEGRAM_BOT},on:{"callback":_vm.onTelegramAuth}})}
var staticRenderFns = []

export { render, staticRenderFns }